import {observer} from "mobx-react";
import React, {useEffect, useState} from "react";
import {SingleValue} from "react-select";
import FontBody2 from "../../components/fonts/font-body2/font-body2";
import {FONT_COLOR, FONT_VARIANT} from "../../components/fonts/font-props";
import {DROPDOWN_MENU_WIDTH, IOption, SelectDropdown} from "../../components/inputs/select-dropdown/select-dropdown";
import BasePageLayout from "../../components/layouts/base-page-layout/base-page-layout";
import Card from "../../components/layouts/card/card";
import SearchBar from "../../components/layouts/search-bar/search-bar";
import SearchInput from "../../components/search-input/search-input";
import TableRow from "../../components/table/components/table-row/table-row";
import Table from "../../components/table/table";
import userMasterListStore from "./stores/user-master-list-store";
import UserMasterListStore, {SearchFiltersList} from "./stores/user-master-list-store";
import UserRowStore, {UserMasterListActionsListValues} from "./stores/user-row-store";
import ParentChildModal from "./modals/parent-child-modal";
import EditorLoginReasonModal from "./modals/editor-login-reason-modal";
import { ButtonIcon } from "../../components/inputs/button-icon/button-icon";
import "./user-master-list.scss";
import { Tooltip } from "../../components/tooltip/tooltip";

const UserMasterList:React.FC = observer(()=>{

	useEffect(()=>{
		UserMasterListStore.loadPage(1);
		UserMasterListStore.fetchLoginRoles();
	},[]);

	const changeUserType = (value:SingleValue<IOption>)=> {
		UserMasterListStore.setSearchUserType(value as IOption);
		UserMasterListStore.loadPage(1);
	}

	const [showParentStoreModal, setParentStoreModalShow] = useState(false);
    const [userForEditorLogin, setUserForEditorLogin] = useState<UserRowStore | null>(null);
	const [selectedStore, setSelectedStore] = useState(0);

    const actionChange = (user: UserRowStore, value:SingleValue<IOption>) => {
		const action = value?.value as string;

		switch (action) {
			case UserMasterListActionsListValues.LOGIN_AS_VIEWER:
                user.loginAsViewer();
				break;
            case UserMasterListActionsListValues.LOGIN_AS_EDITOR:
                setUserForEditorLogin(user);
                break;
			case UserMasterListActionsListValues.CONNECT:
			case UserMasterListActionsListValues.DISCONNECT:
			case UserMasterListActionsListValues.SHOW_CONNECTION:
				setSelectedStore(user.id);
				setParentStoreModalShow(true);
				break;
			default:
				break;
		}
	}

	return (
        <div className="users-master-list">
	        <BasePageLayout title='Users Management Lists'>
	        <Card>
		        <SearchBar>
			        <SearchInput value={UserMasterListStore.searchValue} onClick={()=>{UserMasterListStore.loadPage(1)}} onChange={(value)=>{UserMasterListStore.searchValue = value}}/>
			        <SelectDropdown value={UserMasterListStore.searchUserType} onChange={changeUserType} options={SearchFiltersList}></SelectDropdown>
		        </SearchBar>
		        <Table  isLoading={UserMasterListStore.isLoading}
			        pagination={{
				        onSetPage: UserMasterListStore.loadPage,
				        page: UserMasterListStore.page,
				        total: UserMasterListStore.total,
				        perPage: UserMasterListStore.perPage
			        }}
			        sort={{
				        onSort: UserMasterListStore.sortData,
				        by: UserMasterListStore.sortBy,
				        dir: UserMasterListStore.sortDir,
			        }}
		        columns={[
			        {content: 'ID', width: {value:0.3,type:'fr'}, sortBy: 'id', sortable: true},
			        {content: 'NAME/EMAIL', width: {value:1.2,type:'fr'}, sortBy: 'email', sortable: true},
			        {content: 'TYPE', width: {value:0.5,type:'fr'}, sortBy: 'user_access', sortable: true},
			        {content: 'PLATFORM', width: {value:0.5,type:'fr'}, sortBy: 'platform', sortable: true},
			        {content: 'CURRENT PLAN', width: {value:0.25,type:'fr'}},
			        {content: 'MOVE-TO PLAN', width: {value:0.25,type:'fr'}},
			        {content: 'SHOPIFY PLAN', width: {value:1,type:'fr'}, sortBy:'shopify_plan_display_name', sortable: true},
			        {content: 'ACTION', width: {value: 130,type:'px'}},
		        ]} totalResultsTitle='Users'>
			        {
						UserMasterListStore.list.map((user:UserRowStore) => (
						<TableRow
							key={user.id}
							cells={[
								<span>{user.id}</span>,
								<span>{user.nameToShow}</span>,
								<span>{user.user_access}</span>,
								<span>{user.platform}</span>,
								<span><FontBody2 color={FONT_COLOR.PRIMARY3_50} variant={FONT_VARIANT.UPPERCASE}>{user.currentPlanColumn}</FontBody2></span>,
								<span>{user.move_to_plan}</span>,
								<span><FontBody2 color={FONT_COLOR.PRIMARY3_50} variant={FONT_VARIANT.UPPERCASE}>{user.shopify_plan_display_name}</FontBody2></span>,
								<span className="action-buttons">
									{user.getActionList.map((action) => (
										<Tooltip content={<FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>{action.label}</FontBody2>}>
											<ButtonIcon key={action.value} Component={action.icon} color={action.color} onClick={() => actionChange(user, action)} />
										</Tooltip>
									))}
								</span>
								]
						}/>))}
		        </Table>
	        </Card>
				{ showParentStoreModal &&
					<ParentChildModal userMasterListStore={UserMasterListStore} userId={selectedStore} onCloseClick={() => setParentStoreModalShow(false)} />
				}
                {
                    userForEditorLogin && (
                        <EditorLoginReasonModal
                            onCloseClick={() => setUserForEditorLogin(null)}
                            onLoginAsEditor={(reason: string) => {
                                userForEditorLogin.loginAsEditor(reason);
                                setUserForEditorLogin(null);
                            }}
                        />
                    )
                }
	        </BasePageLayout>
        </div>
    )
})

export default UserMasterList;
